import { DatePicker } from "zaman";
import React, { useState } from "react";
import Text from "../../../assets/icon/NewsIcons/MainAdmin/NewsText"
import Report from "../../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import Search from "../../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import { MainAdminNewsesTopDropDown } from "../../"
import Cookies from 'universal-cookie';



const MainAdminNewsesTop = (props) => {
    const cookies = new Cookies();

    const dateItems = ["فرودین", "اردیبهشت", "خرداد", "مرداد"];
    const showItems = [{ label: "مهم ترین اخبار", set: props.setLast }, { label: "اخبار پر بازدید", set: props.setMost }, 
        { label: "اخبار شاخص دسته بندی", set: props.setProminent }, { label: "اخبار بالای صفحه اصلی", set: props.setMain }];
    const groupItems = ["طلا و ارز", "سیاسی", "فرهنگی", "اجتماعی"];
    const writerItems = ["علیرضا بابایی", "علی مدانلو", "امیر مفید", "آرمان مسلمی"];
    const fixNumbers = function (str) {
        var
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
        if (typeof str === 'string') {
            for (var i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };
    const formatDateTime = (sDate) => {
        console.log(sDate)
        var lDate = new Date(sDate).toLocaleDateString('fa-IR');
        console.log(555)
        console.log(lDate)
        var d = fixNumbers(lDate.split('/')[2]);
        var dd = d < 10 ? '0' + d : d;
        var yyyy = fixNumbers(lDate.split('/')[0]);
        var mon = fixNumbers(lDate.split('/')[1]);
        var mm = (mon < 10 ? '0' + mon : mon);


        return yyyy + '/' + mm + '/' + dd;


    }
    const [labelAdmin, setLabelAdmin] = useState();
    const [labelCat, setLabelCat] = useState();
    const [labelArt, setLabelArt] = useState();

    return (
        <div className="pt-[25px] px-[20px] border-b-2 border-borderGray">
            <div className="w-full flex justify-between items-center mb-[40px]">
                <div className="flex justify-start items-center">
                    <div><Text /></div>
                    <p className="font-IRANYekanExtra text-[15px] text-mainColor2 mr-[15px]">{props.children}</p>
                </div>
                <div className="flex items-center">
                    <div className="w-[238px] ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e)=>props.setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button  onClick={()=>props.setBtnSearch(!props.btnSearch)}><Search /></button>
                    </div>
                    <div className="w-[121px] h-[40px] bg-Orange2 hoverBgYellow shadow-search-shadow rounded-[10px] flex justify-center items-center">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </div>
                </div>
            </div>
            <div className="w-full flex justify-start items-center mb-[40px]">
                <div className="flex items-center">
                    <div className="w-[143px] ml-[15px]">
                        <p className="font-IRANYekanBold text-[15px] text-mainColor2">مرتب سازی بر اساس :</p>
                    </div>
                    {/* <div className="w-[163px] ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                        <MainAdminNewsesTopDropDown
                            mainText={"تاریخ انتشار"}
                            items={dateItems}
                            mainTextSize={15} /></div> */}
                    <div className="w-[195px] ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                        <MainAdminNewsesTopDropDown 
                        mainText={labelCat?labelCat:"انتخاب دسته بندی"}
                            items={props.cats}
                            set={props.setCat}
                            setLabel={setLabelCat}
                            mainTextSize={15} /></div>
                            {
                                        
                                       cookies.get('role') == "Admin"?
                                       <div className="w-[195px] ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                                           <MainAdminNewsesTopDropDown
                                               mainText={labelAdmin?labelAdmin:"نویسنده"}
                                               items={props.admins}
                                               set={props.setAdmin}
                                               setLabel={setLabelAdmin}
                                               mainTextSize={15} /></div>
                                               :
                                               null
                                            }
                                            </div>
                {props.mode == true ?
                <div className="flex items-center mr-4">
                    <div className="w-[148px] ml-[15px]">
                        <p className="font-IRANYekanBold text-[15px] text-mainColor2">نمایش اخبار بر اساس :</p>
                    </div>
                    <div className="w-[223px] ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                        <MainAdminNewsesTopDropDown
                            mainText={labelArt?labelArt:"فیلتر اخبار"}
                            items={showItems}
                            all={true}
                            setLabel={setLabelArt}
                            mainTextSize={15} /></div>
                </div>
                :
                null
                }

            </div>
            {props.mode == true ?
            <div className="w-full flex justify-start items-center mb-[20px]">
               <p className="font-IRANYekanBold text-[15px] text-mainColor2 ml-[15px]">مرتب سازی بر اساس بازه زمانی :</p>
               <div className="w-[180px] flex justify-start items-center px-3 ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
               <DatePicker placeholder="تاریخ"
                name="startDate"
                value={props.start}
                onChange={(e) => {
                  // setAllValues({ ...allValues,TravelDate:formatDateTime(e.value)});
                //   setAllValuesError({ ...allValuesError, TravelDate: false }); 
                props.setStart(formatDateTime(e.value));
                }}

              /></div>
              <p className="font-IRANYekanBold text-[15px] text-mainColor2 ml-[15px]">لغایت</p>
              <div className="w-[180px] flex justify-start items-center px-3 ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
               <DatePicker placeholder="تاریخ"
                name="endDate"
                value={props.end}
                onChange={(e) => {
                //   // setAllValues({ ...allValues,TravelDate:formatDateTime(e.value)});
                //   setAllValuesError({ ...allValuesError, TravelDate: false });
                props.setEnd(formatDateTime(e.value)); 
                }}

              /></div>
              
            </div>
            :
            null
            }
        </div>
    )
}

export default MainAdminNewsesTop;